<div
  [ngClass]="(combinedFiles$ | async)?.length === 0 ? 'empty' : ''"
  class="container"
>
  <div class="flex flex-col h-full">
    @if (convertedFiles$ | async; as convertedFiles) {
      <app-file-box
        [class.blocked]="isFileBoxBlocked$ | async"
        [compactMode]="(combinedFiles$ | async)!.length > 0"
        [ngClass]="
          (combinedFiles$ | async)!.length === 0
            ? '!min-h-[18rem]'
            : '!min-h-[7rem] !max-h-[7rem]'
        "
        class="file-box"
      />

      @if (allQueueFiles$ | async; as allQueueFiles) {
        @if (allQueueFiles.length > 0 || convertedFiles.length > 0) {
          <div class="converter-wrapper">
            @if (allQueueFiles.length > 0) {
              <div class="queues-section">
                <div class="queue-header">
                  <p class="queue-title">
                    {{ "home.queue.title" | translate }}
                    {{ allQueueFiles.length }}
                  </p>
                  @if (!(isAnyQueueLocked$ | async)) {
                    <button
                      (click)="clearBothQueues()"
                      class="clear-queue-btn-small"
                      style="width: auto"
                    >
                      {{ "home.queue.clear" | translate }}
                    </button>
                  }
                </div>

                <div
                  [class.locked]="isAnyQueueLocked$ | async"
                  class="scroll-area-column"
                >
                  <div
                    (cdkDropListDropped)="drop($event, allQueueFiles)"
                    cdkDropList
                  >
                    @for (file of allQueueFiles; track file.fileId) {
                      <app-processing-file-card
                        [class.blocked]="isFileBoxBlocked$ | async"
                        [conversionId]="file.conversionId"
                        [conversionMode]="file.conversionMode"
                        [fileId]="file.fileId"
                        [fileName]="file.fileName"
                        [fileSize]="file.fileSize / 1024"
                        [queuePosition]="$index"
                        [status]="file.status"
                        cdkDrag
                        class="w-full"
                      />
                    }
                  </div>
                </div>

                <div class="queue-actions">
                  @if (!(isAnyQueueLocked$ | async)) {
                    <button
                      (click)="sendBothQueues()"
                      class="convert-files-button"
                    >
                      {{ "home.actions.convertAll" | translate }}
                    </button>
                  } @else {
                    <button (click)="cancelBothQueues()" class="stop-button">
                      {{ "home.actions.stopAll" | translate }}
                    </button>
                  }
                </div>
              </div>
            }

            @if (convertedFiles.length > 0) {
              <div class="converted-section">
                @if (!showCheckboxes) {
                  <button (click)="toggleCheckboxes()" class="upload-btn">
                    {{ "home.actions.selectToDownload" | translate }}
                  </button>
                }

                <div class="converted-tab">
                  @if (showCheckboxes) {
                    @if (convertedFilesCount$ | async; as count) {
                      <div class="select-btn-div">
                        <button
                          (click)="selectAllFiles(convertedFiles)"
                          class="select-converted-files-btn"
                        >
                          {{ "home.selection.selectAll" | translate }}
                        </button>
                        <button
                          (click)="clearSelectedFiles()"
                          [disabled]="selectedFiles.length === 0"
                          class="clear-selected-files-btn"
                        >
                          {{ "home.selection.clearSelection" | translate }}
                        </button>
                      </div>
                      <p class="count">
                        {{ "home.selection.filesCount" | translate }}
                        {{ count }}
                      </p>
                    }
                  }
                </div>

                <div class="converted-files">
                  @for (file of convertedFiles; track file.fileId) {
                    <div class="flex items-center gap-4">
                      @if (showCheckboxes) {
                        <input
                          (change)="toggleFileSelection(file)"
                          [checked]="selectedFiles.includes(file)"
                          class="cursor-pointer size-4"
                          type="checkbox"
                        />
                      }
                      <app-converted-file-card
                        [convertedFileName]="file.convertedFileName"
                        [fileId]="file.fileId"
                        [fileName]="file.fileName"
                        [fileSize]="file.fileSize / 1024"
                        [fileUrl]="file.fileUrl"
                        [status]="file.status"
                        class="!w-[100%]"
                      />
                    </div>
                  }
                </div>

                @if (showCheckboxes) {
                  <div class="converted-files-actions">
                    <button
                      (click)="downloadConvertedFiles()"
                      [disabled]="this.selectedFiles.length === 0"
                      class="download-converted-files-button"
                    >
                      {{ "home.actions.downloadSelected" | translate }}
                      <span class="material-symbols-rounded download"
                        >download</span
                      >
                    </button>
                    <button
                      (click)="callClearConvertedFilesConfirmation()"
                      class="clear-converted-files-btn"
                    >
                      {{ "home.actions.deleteConverted" | translate }}
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        }
      }
    }
  </div>

  @if (showConfirmation) {
    <app-confirmation-modal
      (cancel)="showConfirmation = false"
      (confirm)="clearConvertedFiles()"
      [message]="'home.confirmModal.message' | translate"
      class="confirmation-modal"
    />
  }
</div>

@if (showConvertedLimitModal) {
  <app-confirmation-modal
    (cancel)="showConvertedLimitModal = false"
    (confirm)="confirmProcessQueue()"
    [message]="'home.confirmModal.convertedLimitMessage' | translate"
    [title]="'home.confirmModal.convertedLimitTitle' | translate"
    class="confirmation-modal"
  />
}
